// extracted by mini-css-extract-plugin
export var phone = "_3p-0";
export var phoneDragging = "_3p-1";